import React, {Component} from 'react';
import BRSpan from '../../General/BRSpan';
import _ from 'lodash';
class DonorFullPage extends Component {
  renderColumns = () => {
    let sort = _.get(this.props, 'sort', 'column');
    let fontSize = .0215053763440860215 * this.props.width;
    let columnDonors = [];
    let columnWidth = this.props.width / this.props.columns;
    if (this.props.overridePadding) {
      columnWidth -= this.props.overridePadding * 2;
    }
    if (this.props.overrideFontSize) {
      fontSize = this.props.overrideFontSize;
    }

    if (sort === "column") {
      for (let i = 0; i < this.props.donorData.length; i++) {
        const columnIndex = i % this.props.columns;
        if (!columnDonors[columnIndex]) {
          columnDonors[columnIndex] = [];
        }
        columnDonors[columnIndex].push(this.props.donorData[i]);
      }
    } else {
      const rest = this.props.donorData.length % this.props.columns;
      const donorsPerColumn = Math.floor(this.props.donorData.length / this.props.columns);
      const lastColumnTakeAway = rest === 0 ? 0 : this.props.columns - rest;
      let sumDonorsColumns = 0;
      for (let i = 0; i < this.props.columns; i++) {
        let totalDonorsColumn = donorsPerColumn;
        if (lastColumnTakeAway > 0 && i < this.props.columns - 1) {
          totalDonorsColumn++;
        }
        if (lastColumnTakeAway > 0 && i === this.props.columns - 1) {
          totalDonorsColumn -= lastColumnTakeAway;
        }
        columnDonors[i] = this.props.donorData.slice(sumDonorsColumns, sumDonorsColumns + totalDonorsColumn);
        sumDonorsColumns += totalDonorsColumn;
      }
    }

    let renderedColumns = columnDonors.map((donors, i) => {
      let renderedDonors = donors.map((donor, j) => {
        const text1 = _.get(donor.contents, 'texts[0].text', null);
        return (
          <div key={j}>
            <p style={{ fontSize: fontSize, marginBlockEnd: this.props.screen.screenWidth * .00462962962962962963 }} ><BRSpan preWrap str={donor.name}/></p>
            {
              text1 ?
              <p style={{ paddingLeft: this.props.width * .04878615402485770705, fontSize: .0215053763440860215 * this.props.width, marginBlockStart: 0, marginBlockEnd: this.props.screen.screenWidth * .02777777777777777778 }}>{text1}</p>
              : null
            }
          </div>
        )
      });
      const paddingRight = this.props.overridePadding ? this.props.overridePadding : 0;
      const paddingLeft = this.props.overridePadding ? this.props.overridePadding : 0;
      return (
        <div key={i} style={{ width: columnWidth, float:"left", paddingLeft: paddingLeft, paddingRight: paddingRight }}>
          {renderedDonors}
        </div>
      );
    });

    return renderedColumns;
  }

  render() {
    const columns = this.renderColumns();
    return (
      <div>
        {columns}
      </div>
    );
  }
}

export default DonorFullPage


// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/DonorFullPage.jsx